import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";
import { Spinner } from "@/components/ui/spinner";
import { GmbLocation } from "api/social-account-connect/google";

import { GoogleMyBusinessLocationList } from "../google-my-business-location-list";
import { NeedHelpButton } from "../need-help-button";
import { addGmbLocationFx, loginWithGoogleFx } from "./model";
import { getConnectButtonStateFactory } from "../connect-button";
import { PlatformTypes } from "features/post";
import {
  dispatchAppAction,
  selectSocialConnectGmbState,
  socialAccountConnectActions,
} from "../../redux-model";

interface GoogleMyBusinessConnectDialogProps {
  show: boolean;

  onHide(): void;

  onBack(): void;

  isAlreadyAdded(chan: GmbLocation): boolean;
}

export function GoogleMyBusinessConnectDialog({
  show,
  onHide,
  onBack,
  isAlreadyAdded,
}: GoogleMyBusinessConnectDialogProps) {
  const { locations, isLoggingIn, isGettingChannels, connectingGmbLocationId } =
    useSelector(selectSocialConnectGmbState);

  useEffect(() => {
    return () => {
      if (show) {
        dispatchAppAction(socialAccountConnectActions.resetGmbDialogState());
      }
    };
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Google Business Profile connection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {locations ? (
          <GoogleMyBusinessLocationList
            locations={locations}
            onConnect={(location) => addGmbLocationFx(location)}
            getConnectButtonState={getConnectButtonStateFactory({
              isConnected: isAlreadyAdded,
              isConnecting: (page) => page.id === connectingGmbLocationId,
              isDisabled: () => Boolean(connectingGmbLocationId) || isLoggingIn,
            })}
            LoginWithGoogleButtonProps={{
              disabled:
                isLoggingIn ||
                Boolean(connectingGmbLocationId) ||
                isGettingChannels,
              onClick: () => void loginWithGoogleFx(),
            }}
          />
        ) : (
          <div className="flex items-center justify-center py-8">
            <Spinner size="lg" />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={onBack}>
          Back
        </Button>
        <NeedHelpButton
          platform={PlatformTypes.googlemybusiness}
          chatQuery="accounts"
        />
      </Modal.Footer>
    </Modal>
  );
}
